import dynamic from "next/dynamic";

export const DynamicLayoutWidget013 = dynamic(
  () => import("./LayoutWidget013"),
  {
    suspense: true,
  }
);
